import React from 'react';
import { useTranslation } from 'react-i18next';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

const AboutBox = () => {
  const { t } = useTranslation();

  return (
    <div className="about__boxes grid">
      <div className="about__box">
        <i className="about__icon icon-fire"></i>
        <div>
          <h3 className="about__title">
            <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
              {({ isVisible }) => (
                <CountUp end={5} duration={2} start={isVisible ? undefined : 0} />
              )}
            </VisibilitySensor>
          </h3>
          <span className="about__subtitle">{t('servers_not_on_fire')}</span>
        </div>
      </div>

      <div className="about__box">
        <i className="about__icon icon-cup"></i>
        <div>
          <h3 className="about__title">
            <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
              {({ isVisible }) => (
                <div>
                  <CountUp end={1000} duration={3} start={isVisible ? undefined : 0} />+
                </div>
              )}
            </VisibilitySensor>
          </h3>
          <span className="about__subtitle">{t('cups_of_tea')}</span>
        </div>
      </div>

      <div className="about__box">
        <i className="about__icon icon-people"></i>
        <div>
          <h3 className="about__title">
            <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
              {({ isVisible }) => (
                <CountUp end={42} duration={2.5} start={isVisible ? undefined : 0} />
              )}
            </VisibilitySensor>
          </h3>
          <span className="about__subtitle">{t('happy_clients')}</span>
        </div>
      </div>

      <div className="about__box">
        <i className="about__icon icon-badge"></i>
        <div>
          <h3 className="about__title">
            <VisibilitySensor partialVisibility offset={{ bottom: 200 }}>
              {({ isVisible }) => (
                <CountUp end={0} duration={1} start={isVisible ? undefined : 0} />
              )}
            </VisibilitySensor>
          </h3>
          <span className="about__subtitle">{t('awards_won')}</span>
        </div>
      </div>
    </div>
  );
};

export default AboutBox;